export const FOLDER_SUMMARY_CHANGED = "Charisma.Leasing.PublishedLanguage.Events.LeasingFolder.FolderSummaryChanged";
